const initialState = {
  payments: null,
  channels: null,
  sellPaymentsModalActive: false,
  filtersFormState: {
    data: {
      sort: 'remainingValue',
    }
  },
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case 'TOGGLE_SELL_PAYMENTS_MODAL': {
      return {
        ...state,
        sellPaymentsModalActive: payload.active,
      };
    }
    case 'SET_SELL_PAYMENTS': {
      return {
        ...state,
        payments: payload.payments,
      };
    }
    case 'SET_SELL_CHANNELS': {
      return {
        ...state,
        channels: payload.channels,
      };
    }
    case 'SELL_PAYMENT_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsPanel.reducer.js